<div class="small-banner-container" [class]="{
  'banner-info': adjustedConfig().style === BannerStyle.Info,
  'banner-error': adjustedConfig().style === BannerStyle.Error,
  'banner-warning': adjustedConfig().style === BannerStyle.Warning,
  'banner-success': adjustedConfig().style === BannerStyle.Success,
  }">
  <div class="small-banner-left" [style.align-items]="adjustedConfig().description ? 'flex-start' : 'center'">
    <mat-icon class="small-banner-title-icon" [hidden]="!adjustedConfig().icon" [svgIcon]="adjustedConfig().icon ?? ''"></mat-icon>
    <div class="small-banner-title">
      <div [hidden]="!adjustedConfig().title" class="small-banner-title-text">
        {{ adjustedConfig().title }}
      </div>
      <div [hidden]="!adjustedConfig().description" class="small-banner-description-text">
        {{ adjustedConfig().description }}
      </div>
    </div>
  </div>
  <div class="small-banner-buttons">
    @for (button of adjustedConfig().buttons; track $index) {
      <lib-button [leadingIconName]="button.leadingIconName" [trailingIconName]="button.trailingIconName"
                  [type]="button.style" (buttonClick)="button.onClick()" [size]="InputSize.small"> {{ button.title }}
      </lib-button>
    }
  </div>
  @let closeButtonClicked = adjustedConfig().closeButtonClicked;
  @if (closeButtonClicked) {
    <mat-icon class="small-banner-cross-icon" (click)="closeButtonClicked()" svgIcon="close"></mat-icon>
  }
</div>
